<template>
  <BaseClearButton v-bind="$attrs" class="opacity-70" @click="open()" color="white" size="small">{{
    appInfo.appVersion
  }}</BaseClearButton>
  <IonModal ref="versionModalRef">
    <IonHeader>
      <IonToolbar color="white">
        <IonTitle color="medium">What's New?</IonTitle>
        <IonButtons slot="end">
          <IconButton @click="versionModalRef?.$el?.dismiss()" icon="icon-x" color="primary"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent class="whats-new-modal">
      <div class="absolute top-12 text-center w-full font-medium text-2xl">
        See What's New <span class="font-bold text-blue-300">{{ appVersionWithoutBuild }}</span>
        <div class="font-light text-gray-500 pt-4">{{ date }}</div>
      </div>
      <div class="max-w-full flex items-center justify-center mt-8 mb-12 mx-4">
        <img class="max-h-full max-w-full" src="@/assets/whats-new-stars.svg" />
      </div>
      <ul class="max-w-full mx-14 mb-0">
        <li class="list-item text-base text-gray-700 max-w-80 mt-6" v-for="item of features">{{ item }}</li>
      </ul>
      <div v-if="bugs.length" class="text-center mt-10 mb-0 text-gray-700 font-medium text-lg">Bug Fixes</div>
      <ul class="max-w-full m-14 mt-0 mb-10">
        <li class="list-item text-base text-gray-700 max-w-80 mt-6" v-for="item of bugs">{{ item }}</li>
      </ul>
    </IonContent>
  </IonModal>
</template>
<script lang="ts">
export default { inheritAttrs: false };
</script>
<script setup lang="ts">
import { useAppInfo } from '@/stores/app-info.store';
import BaseClearButton from '../forms/BaseClearButton.vue';
import { IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from '@ionic/vue';
import { computed, useTemplateRef, onMounted } from 'vue';
import IconButton from '../forms/IconButton.vue';
import { usePreferenceStorage } from '@/composables/use-preference-storage';

const appInfo = useAppInfo();
const versionModalRef = useTemplateRef('versionModalRef');

const version = computed(() => appInfo.appVersion);
const date = '16.Oct.2025';
const features: string[] = ['Various upgrades to improve overall app performance and stability'];
const bugs: string[] = ['Fixed issues with configuring Remote Readers in Pulse Out mode'];
const { state: lastViewedVersion, waitForInit } = usePreferenceStorage('ncss-whats-new-version-viewed');
const appVersionWithoutBuild = computed(() => {
  const parts = version.value.split('.');
  return parts.slice(0, parts.length - 1).join('.');
});

onMounted(() => {
  waitForInit().then(() => {
    if (!lastViewedVersion.value) {
      return;
    }
    if (appVersionWithoutBuild.value && lastViewedVersion.value !== appVersionWithoutBuild.value) {
      open();
    }
  });
});

function open() {
  versionModalRef.value?.$el?.present();
  lastViewedVersion.value = appVersionWithoutBuild.value;
}
</script>

<style scoped>
.list-item:before {
  content: '';
  position: absolute;
  margin-top: 4px;
  left: 25px;
  width: 16px;
  height: 16px;
  background-image: url('@/assets/single-star.svg');
}
ion-content.whats-new-modal {
  --background: linear-gradient(180deg, #fefefe 0%, #e0eff9 30%, #bfc3c6 100%);
}
</style>
